import { type PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { FilesHistoryState, TCurrentRevision } from "./types";

const initialState: FilesHistoryState = {
  currentRevisionLoading: true,
  restoreRevisionLoading: false,
  duplicateRevisionLoading: false,
  currentRevision: undefined,
};

export const filesHistory = createSlice({
  name: "files-history",
  initialState,
  reducers: {
    setCurrentRevisionLoading: (
      state: FilesHistoryState,
      action: PayloadAction<boolean>,
    ) => {
      state.currentRevisionLoading = action.payload;
    },
    setRestoreRevisionLoading: (
      state: FilesHistoryState,
      action: PayloadAction<boolean>,
    ) => {
      state.restoreRevisionLoading = action.payload;
    },
    setDuplicateRevisionLoading: (
      state: FilesHistoryState,
      action: PayloadAction<boolean>,
    ) => {
      state.duplicateRevisionLoading = action.payload;
    },
    setCurrentRevision: (
      state: FilesHistoryState,
      action: PayloadAction<TCurrentRevision | null>,
    ) => {
      state.currentRevision = action.payload;
    },
    resetFilesHistoryState: () => initialState,
  },
});

export const {
  setCurrentRevisionLoading,
  setRestoreRevisionLoading,
  setDuplicateRevisionLoading,
  setCurrentRevision,
  resetFilesHistoryState,
} = filesHistory.actions;
